window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-attributes-more:not(.initialized)').forEach(more => {
    more.addEventListener('click', e => {
      e.preventDefault();

      more.closest('.product-attributes-container').querySelectorAll('.product-attribute-more').forEach(attribute => attribute.classList.remove('product-attribute-more'));
      more.remove();
    });

    more.classList.add('initialized');
  });
});